<template>
    <div class="formgrid grid">
        <div class="field-radiobutton col-12 xl:col-6 flex-order-0">
            <RadioButton
                v-model="srokLocal"
                :inputId="getUID('month_1')"
                :value="TariffTime.ONE_MONTH_ID"
                :disabled="isDisabled(TariffTime.ONE_MONTH_ID)"
            />
            <label :for="getUID('month_1')">{{ $t('lang.main.month_1') }}</label>
        </div>
        <div class="field-radiobutton col-12 xl:col-6 flex-order-1 xl:flex-order-2">
            <RadioButton
                v-model="srokLocal"
                :inputId="getUID('month_3')"
                :value="TariffTime.THREE_MONTHS_ID"
                :disabled="isDisabled(TariffTime.THREE_MONTHS_ID)"
            />
            <label :for="getUID('month_3')" class="tariff_selector__month_label">
                {{ $t('lang.main.month_3') }}
                <Badge :value="getBadgeLabel(tariffPercent[1])"/>
            </label>
        </div>
        <div class="field-radiobutton col-12 xl:col-6 flex-order-2 xl:flex-order-1">
            <RadioButton
                v-model="srokLocal"
                :inputId="getUID('month_6')"
                :value="TariffTime.HALF_YEAR_ID"
                :disabled="isDisabled(TariffTime.HALF_YEAR_ID)"
            />
            <label :for="getUID('month_6')" class="tariff_selector__month_label">
                {{ $t('lang.main.month_6') }}
                <Badge :value="getBadgeLabel(tariffPercent[2])"/>
            </label>
        </div>
        <div class="field-radiobutton col-12 xl:col-6 flex-order-3">
            <RadioButton
                v-model="srokLocal"
                :inputId="getUID('month_12')"
                :value="TariffTime.ONE_YEAR_ID"
                :disabled="isDisabled(TariffTime.ONE_YEAR_ID)"
            />
            <label :for="getUID('month_12')" class="tariff_selector__month_label">
                {{ $t('lang.main.month_12') }}
                <Badge :value="getBadgeLabel(tariffPercent[3])"/>
            </label>
        </div>
        <div class="field-radiobutton col-12 xl:col-12 flex-order-4" v-if="showConvertTariff">
            <RadioButton
                v-model="srokLocal"
                inputId="convertTariff"
                :value=10
            />
            <label for="convertTariff">{{ pluralizeDays(convertDays) }}</label>
        </div>
    </div>
</template>

<script>
import uniqueId from "lodash/uniqueId";
import {TariffTime, TariffDaysMap} from "../../page/tariff/constants/tariffTime";
import Badge from "primevue/badge";
import RadioButton from "primevue/radiobutton";

export default {
    name: "SubscriptionSrok",
    emits: ['update:srok'],
    props: {
        srok: {
            type: Number,
            required: true,
        },
        tariffPercent: {
            type: Object,
            required: true,
        },
        isPromo: {
            type: Boolean,
            required: false,
            default: null,
        },
        allPrices: {
            type: Object,
            required: false
        },
        tarif: {
            type: Number,
            required: false,
            default: null,
        },
        balanceInDays: {
            type: Number,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            uid: uniqueId('srok'),
            srokLocal: null,
            convertDays: 0,
        };
    },
    mounted() {
        this.srokLocal = this.srok;
        this.recalculateConvertDays();
    },
    methods: {
        getUID(slug) {
            return this.uid + '_' + slug;
        },
        getBadgeLabel: percentValue => '-' + percentValue + '%',
        recalculateConvertDays() {
            if (!this.allPrices || !this.allPrices[this.tarif]) return;

            const prices = this.allPrices[this.tarif];

            for (let i = 0; i < prices.length; i++) {
                const price = prices[i];
                const previous = i > 0 ? prices[i - 1] : null;

                if (price[1] > this.balanceInDays) {
                    this.convertDays = Math.ceil(this.balanceInDays / (previous ? previous[0] : price[0]));
                    return;
                }

                if (i === prices.length - 1) {
                    this.convertDays = Math.ceil(this.balanceInDays / price[0]);
                }
            }
        },
        pluralizeDays(number) {
            const cases = [2, 0, 1, 1, 1, 2];
            const titles = ["день", "дня", "дней"];
            return "конвертировать текущий тариф в " + number + " " + titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[Math.min(number % 10, 5)]] + " подписки";
        },
        isDisabled(srok) {
            let disabled = TariffDaysMap[srok] < this.convertDays
            if (disabled && this.srokLocal === srok) {
                this.srokLocal = this.srokLocal + 1
                if (this.srokLocal > TariffTime.ONE_YEAR_ID) {
                    this.srokLocal = 10
                }
            }
            return disabled
        },
    },
    computed: {
        TariffTime() {
            return TariffTime
        },
        getSrok() {
            return this.srok;
        },
        showConvertTariff() {
            return this.convertDays > 0
        }
    },
    watch: {
        srokLocal(val) {
            this.$emit('update:srok', val);
        },
        tarif() {
            this.recalculateConvertDays();
        },
        srok(val) {
            this.srokLocal = val;
        }
    },
    components: {
        Badge,
        RadioButton,
    }
}
</script>
